import { Component, inject, input, model, OnInit } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { HeadlineService } from './headline.service';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-headline',
  templateUrl: './headline.component.html',
  imports: [NgTemplateOutlet, TranslatePipe, NgClass],
})
export class HeadlineComponent implements OnInit {
  cssClass = input<string>();
  iconClass = input<string>();
  text = input<string>();
  style = input<string>();
  textParams = input<any>();
  headlineLevelIncrement = input<number>();
  headlineNodeType = model<TextNodeType>();

  private headlineService = inject(HeadlineService);

  ngOnInit() {
    if (!this.headlineNodeType()) {
      this.headlineNodeType.set(this.headlineService.getHeadline(this.headlineLevelIncrement()));
    }
  }
}
